/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getUproColor } from "utils/colors";
import { makeNiceText } from "utils/formatters";
import SoftBadge from "components/SoftBadge";
const getRows = (data, handleOpenMenu) => {
  const rows = [];

  const getEstado = (estado) => {
    switch (estado) {
      case "PENDIENTE":
        return { icon: "access_time", color: getUproColor("uproYellow"), text: "Pendiente" };
      case "APROBADO":
        return { icon: "check", color: getUproColor("uproGreen"), text: "Aprobado" };
      case "RECHAZADO":
        return { icon: "close", color: getUproColor("uproPink"), text: "Rechazado" };
      default:
        return { icon: "access_time", color: getUproColor("uproYellow"), text: "Pendiente" };
    }
  };
  if (data) {
    data.forEach((item) => {
      let sedes = [];
      rows.push({
        type: (
          <SoftBox
            display="flex"
            alignItems="center"
            sx={{
              cursor: "pointer",
            }}
            data={
              <Icon
                sx={{
                  verticalAlign: "middle",
                  cursor: "pointer",
                  color: getEstado(item?.estado)?.color,
                }}
                fontSize="lg"
              >
                {getEstado(item?.estado)?.icon}
              </Icon>
            }
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftBox pl={3} mr={2}>
              <Tooltip title={getEstado(item?.estado)?.text} placement="top">
                <Icon
                  sx={{
                    verticalAlign: "middle",
                    cursor: "pointer",
                    color: getEstado(item?.estado)?.color,
                  }}
                  fontSize="lg"
                >
                  {getEstado(item?.estado)?.icon}
                </Icon>
              </Tooltip>
            </SoftBox>
          </SoftBox>
        ),
        id: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            data={item?.id}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="bold"
            >
              {item?.id}
            </SoftTypography>
          </SoftBox>
        ),
        nombre: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            data={
              item?.nombre
                ? makeNiceText(item?.nombre + " " + item?.apellido, "nombre")
                : item?.username
            }
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.nombre
                ? makeNiceText(item?.nombre + " " + item?.apellido, "nombre")
                : "Sin nombre"}
            </SoftTypography>
          </SoftBox>
        ),
        tipoUsuario: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
            data={item?.tipoUsuario}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.tipoUsuario || "Sin especificar"}
            </SoftTypography>
          </SoftBox>
        ),
        tipoDocumento: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
            data={item?.tipoDocumento}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.tipoDocumento || "Sin especificar"}
            </SoftTypography>
          </SoftBox>
        ),
        dni: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="medium"
            >
              {item?.dni || "Sin especificar"}
            </SoftTypography>
          </SoftBox>
        ),
        email: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="medium"
            >
              {item?.email || "Sin especificar"}
            </SoftTypography>
          </SoftBox>
        ),
        convenio: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="medium"
            >
              {item?.convenio?.nombreInstitucion || "Sin especificar"}
            </SoftTypography>
          </SoftBox>
        ),
        localidad: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="medium"
            >
              {item?.localidad
                ? item?.localidad?.nombre + ", " + item?.localidad?.provincia?.nombre
                : "Sin especificar"}
            </SoftTypography>
          </SoftBox>
        ),
        estado: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            data={item?.estado}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <Tooltip title={item?.motivoRechazo ? `Motivo: ${item?.motivoRechazo}`: ""} placement="top">
              <SoftBadge
                variant="color"
                color={getEstado(item?.estado)?.color}
                badgeContent={item?.estado}
              />
            </Tooltip>
          </SoftBox>
        ),
        accion: (
          <SoftBox
            mr={2}
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <Tooltip title="Opciones" placement="top">
              <Icon
                sx={{ color: getUproColor("uproGreen"), cursor: "pointer", mx: 0.5 }}
                fontSize="small"
                onClick={(e) => handleOpenMenu(e, item)}
              >
                more_vert
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "type", desc: " ", align: "left", width: "1%", noOrder: true },
  { name: "id", desc: "ID", width: "1%", align: "left" },
  { name: "nombre", desc: "Nombre", align: "left" },
  { name: "tipoUsuario", desc: "tipo de usuario", align: "left" },
  { name: "tipoDocumento", desc: "tipo de documento", align: "left" },
  { name: "dni", desc: "DNI/CUIT/CUIL", align: "left" },
  { name: "email", desc: "Email", align: "left" },
  { name: "convenio", desc: "Convenio", align: "left" },
  { name: "localidad", desc: "localidad", align: "left" },
  { name: "estado", desc: "Estado", align: "left" },
  { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
